import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=0cc985b8&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc985b8"]])

export default __exports__